import React, {useState} from "react";

// Components
import TriggerLandmark from "Modules/alerts/components/wizardAlert/common/components/TriggerLandmark";
import {Form} from "@gpstrackit/gtc-react-controls";


export const BasicTriggerLandmark = (props) => {

    const {value, onChange, formRef, triggers, triggersRaw} = props
    const [showErrorTrigger, setShowErrorTrigger] = useState(false)

    return (
        <Form ref={formRef}
              onSubmit={() => {
                  if (value.trigger) {
                      let isValid = triggersRaw?.length > 0

                      if (!isValid) {
                          setShowErrorTrigger(true)
                      } else setShowErrorTrigger(false)
                      return isValid
                  }
              }}>
            <TriggerLandmark config={value} triggers={triggers} triggersRaw={triggersRaw} onChange={onChange} showErrorTrigger={showErrorTrigger}/>
        </Form>
    );
}
